export default __webpack_public_path__ + "static/media/logo_allo_white.7fb19d25.svg";